import Link from 'next/link'

import arrowIcon from '@/shared/assets/icons/arrow.svg'
import { BASE_URL } from '@/shared/lib/const/env'
import { formatDate } from '@/shared/lib/utils/date/format-date'
import Flex from '@/shared/ui/Flex/ui/Flex'
import { Icon } from '@/shared/ui/icon'
import { Image } from '@/shared/ui/Image'

import { SalesItemTypes } from '../../../../../../store/types/sales'

import styles from './PromotionCard.module.scss'

export type PromotionCardProps = {
	CUSTOM_LINK?: string
} & SalesItemTypes

export const PromotionCard = ({
	NAME,
	CODE,
	PREVIEW_PICTURE,
	CUSTOM_LINK,
	ACTIVE_TO
}: PromotionCardProps): JSX.Element => {
	const content = (
		<Flex column full>
			<div className={styles.imageWrap}>
				<Image src={BASE_URL + PREVIEW_PICTURE} width={467} height={179} alt={NAME} />
			</div>
			<div className={styles.text}>
				<h3 className={styles.title}>{NAME}</h3>

				{ACTIVE_TO && <span className={styles.date}>до {formatDate(ACTIVE_TO)}</span>}
				<span className={styles.link}>
					Подробнее <Icon icon={arrowIcon} width={18} height={18} aria-hidden="true" />
				</span>
			</div>
		</Flex>
	)

	if (CUSTOM_LINK) {
		return (
			<article className={styles.serviceItem}>
				<a href={CUSTOM_LINK} target="_blank" rel="noopener noreferrer" className={styles.linkAnchor}>
					{content}
				</a>
			</article>
		)
	}

	return (
		<article className={styles.serviceItem}>
			<Link href={`/sales/${CODE}`} prefetch={false} className={styles.linkAnchor}>
				{content}
			</Link>
		</article>
	)
}
